import { fetchBlogPosts } from "./blogApi";

export interface BlogPost {
  slug: string;
  title: string;
  date: string;
  author: string;
  excerpt: string;
  coverImage: string;
  content: string;
}

export async function getAllPosts(): Promise<BlogPost[]> {
  return await fetchBlogPosts();
}

export async function getPostBySlug(slug: string): Promise<BlogPost | null> {
  try {
    console.log(`Attempting to fetch post with slug: ${slug}`);

    // Get all posts and find the one with matching slug
    const allPosts = await getAllPosts();
    const post = allPosts.find((post) => post.slug === slug);

    if (!post) {
      console.error(`No post found with slug: ${slug}`);
      return null;
    }

    return post;
  } catch (error) {
    console.error("Error fetching post:", error);
    return null;
  }
}

export function formatDate(dateString: string): string {
  const date = new Date(dateString);
  return date.toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
}

export async function getAllPostsSlugs(): Promise<string[]> {
  const posts = await getAllPosts();
  return posts.map((post) => post.slug);
}
